var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCoding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 414,
    viewBox: "0 0 468 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-coding",
    transform: "translate(-181 -1037)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1131",
    "data-name": "Rectangle 1131",
    width: 468,
    height: 414,
    transform: "translate(181 1037)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(206 1038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1365",
    "data-name": "Rectangle 1365",
    width: 94.832,
    height: 179.263,
    transform: "translate(32.354 187.573)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1366",
    "data-name": "Rectangle 1366",
    width: 94.832,
    height: 179.263,
    transform: "translate(4.205 187.573)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M94.362,266.682H13V238.27H94.4Zm-80.4-1h79.4V239.274h-79.4Z",
    transform: "translate(-2.303 -42.213)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M44.32,238.88H75.209v2.164a3.5,3.5,0,0,1-3.5,3.5H47.85a3.5,3.5,0,0,1-3.5-3.5V238.88Z",
    transform: "translate(-7.852 -42.322)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M94.362,310.552H13V282.14H94.4Zm-80.4-1h79.4V283.136h-79.4Z",
    transform: "translate(-2.303 -49.986)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M44.32,282.75H75.209v2.164a3.5,3.5,0,0,1-3.5,3.5H47.85a3.5,3.5,0,0,1-3.5-3.5V282.75Z",
    transform: "translate(-7.852 -50.094)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M94.362,354.421H13V326H94.4Zm-80.4-1h79.4V327h-79.4Z",
    transform: "translate(-2.303 -57.756)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M44.32,326.61H75.209v2.164a3.5,3.5,0,0,1-3.5,3.5H47.85a3.5,3.5,0,0,1-3.5-3.5V326.61Z",
    transform: "translate(-7.852 -57.864)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M94.362,398.291H13V369.87H94.4Zm-80.4-1h79.4V370.874h-79.4Z",
    transform: "translate(-2.303 -65.529)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M44.32,370.48H75.209v2.164a3.5,3.5,0,0,1-3.5,3.5H47.85a3.5,3.5,0,0,1-3.5-3.5V370.48Z",
    transform: "translate(-7.852 -65.637)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1367",
    "data-name": "Rectangle 1367",
    width: 103.011,
    height: 8.928,
    transform: "translate(0 180.867)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1368",
    "data-name": "Rectangle 1368",
    width: 30.971,
    height: 8.928,
    transform: "translate(103.011 180.867)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1369",
    "data-name": "Rectangle 1369",
    width: 4.986,
    height: 9.158,
    transform: "translate(4.205 366.836)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1370",
    "data-name": "Rectangle 1370",
    width: 4.986,
    height: 9.158,
    transform: "translate(34.995 366.836)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1371",
    "data-name": "Rectangle 1371",
    width: 4.986,
    height: 9.158,
    transform: "translate(91.244 366.836)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1372",
    "data-name": "Rectangle 1372",
    width: 4.986,
    height: 9.158,
    transform: "translate(119.368 366.836)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M74.142,190.56l9.594,24.562-5.966-.033L72.99,200Z",
    transform: "translate(-12.931 -33.761)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M33.84,162.99l-3.3,47.05,34.065.716L68.44,162.99Z",
    transform: "translate(-5.411 -28.876)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M38.1,167.54,35.35,206.707l25.327,1.185,3.538-40.582Z",
    transform: "translate(-6.263 -29.642)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M45.007,174.32,42.95,201.852H56.922l2.46-27.532Z",
    transform: "translate(-7.609 -30.884)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1373",
    "data-name": "Rectangle 1373",
    width: 109.947,
    height: 108.03,
    transform: "translate(107.618)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1374",
    "data-name": "Rectangle 1374",
    width: 102.245,
    height: 102.245,
    transform: "translate(111.436 2.954)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1375",
    "data-name": "Rectangle 1375",
    width: 33.358,
    height: 33.358,
    transform: "translate(145.888 37.398)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M295.124,12.08c-1.242,17.732,0,50.744-6.451,67.3s-15.066,33.6-31.218,41.01c-19.9,9.117-43.273,5.258-64.494,10.6-33.259,8.368-57.31,38.887-67.579,71.587s-9.125,67.785-7.891,102.031l169.783,23.615s.9-68.978,15.7-87.8,85.139-35.769,108.367-87.327C432.249,106.689,438.552,33.1,438.552,33.1Z",
    transform: "translate(-20.676 -2.14)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M417.148,101.094c0,.239-15.5-1.646-34.559-4.271S348.137,91.886,348.17,91.7s15.494,1.646,34.559,4.279S417.214,100.863,417.148,101.094Z",
    transform: "translate(-61.684 -16.243)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M414.926,117.893c0,.23-15.494-1.646-34.559-4.279s-34.46-4.888-34.427-5.118,15.494,1.646,34.559,4.271S414.959,117.662,414.926,117.893Z",
    transform: "translate(-61.289 -19.218)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M407.248,135.021c0,.23-15.5-1.687-34.559-4.279s-34.452-4.888-34.419-5.126,15.486,1.646,34.559,4.279S407.273,134.782,407.248,135.021Z",
    transform: "translate(-59.93 -22.251)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M393.246,152.3c0,.23-15.494-1.687-34.559-4.279s-34.452-4.888-34.427-5.126,15.494,1.646,34.559,4.279S393.279,152.029,393.246,152.3Z",
    transform: "translate(-57.448 -25.313)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M370.978,169.543c0,.23-15.494-1.646-34.559-4.279S302,160.376,302,160.146s15.494,1.646,34.559,4.27S371.011,169.3,370.978,169.543Z",
    transform: "translate(-53.504 -28.369)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M465.985,108.116c0,.239-3.834-.189-8.483-.946s-8.393-1.563-8.352-1.794,3.834.189,8.483.946S466.026,107.886,465.985,108.116Z",
    transform: "translate(-79.574 -18.658)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M421.306,83.973c0,.23-15.494-1.646-34.559-4.279s-34.46-4.888-34.427-5.118,15.494,1.646,34.559,4.271S421.339,83.734,421.306,83.973Z",
    transform: "translate(-62.419 -13.209)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M470.113,91c-.041.23-3.843-.189-8.492-.946s-8.393-1.563-8.352-1.794,3.834.189,8.492.946S470.146,90.766,470.113,91Z",
    transform: "translate(-80.304 -15.625)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M425.97,66.842c0,.239-15.494-1.646-34.559-4.271S357,57.684,357,57.446s15.494,1.646,34.559,4.279S426,66.612,425.97,66.842Z",
    transform: "translate(-63.248 -10.174)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M474.773,73.866c0,.239-3.843-.189-8.492-.946s-8.393-1.563-8.352-1.794,3.834.189,8.492.954S474.806,73.636,474.773,73.866Z",
    transform: "translate(-81.13 -12.59)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M428.146,49.723c0,.23-15.494-1.646-34.559-4.279s-34.46-4.888-34.427-5.118,15.494,1.646,34.559,4.271S428.146,49.484,428.146,49.723Z",
    transform: "translate(-63.631 -7.141)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M476.953,56.742c-.041.23-3.843-.189-8.492-.946s-8.385-1.563-8.352-1.81,3.843.189,8.492.946S476.995,56.511,476.953,56.742Z",
    transform: "translate(-81.516 -9.552)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M465.253,123.094c0,.23-3.834-.2-8.483-.954s-8.393-1.555-8.36-1.794,3.843.2,8.492.954S465.295,122.856,465.253,123.094Z",
    transform: "translate(-79.443 -21.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M460.175,143.81c0,.23-3.843-.214-8.5-.987s-8.426-1.58-8.335-1.753c0-.3,3.834.148,8.475.913S460.216,143.58,460.175,143.81Z",
    transform: "translate(-78.545 -24.976)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M452.835,161.4c0,.239-3.843-.214-8.5-.979s-8.426-1.588-8.335-1.761,3.834.148,8.475.913S452.876,161.129,452.835,161.4Z",
    transform: "translate(-77.244 -28.101)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M437.053,178.02c-.041.23-3.843-.214-8.5-.987s-8.434-1.58-8.344-1.753,3.843.148,8.483.913S437.094,177.79,437.053,178.02Z",
    transform: "translate(-74.447 -31.046)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M344.492,189.482c0,.239-23.245-2.855-51.839-6.9s-51.756-7.521-51.723-7.751,23.237,2.855,51.838,6.9S344.525,189.252,344.492,189.482Z",
    transform: "translate(-42.685 -30.971)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M328.18,206.451a5.168,5.168,0,0,1-1.144-.091l-3.291-.428-11.989-1.744-39.5-6.089c-15.42-2.469-29.367-4.682-39.447-6.369l-11.939-2.065c-1.407-.255-2.468-.461-3.234-.617a6.312,6.312,0,0,1-1.111-.288,6.846,6.846,0,0,1,1.144.115l3.291.461,11.972,1.794,39.5,6.13,39.447,6.328,11.939,2.016,3.242.592a6.156,6.156,0,0,1,1.119.255Z",
    transform: "translate(-38.362 -33.442)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M302.311,222.755c.148.148-1.514,0-4.262-.37s-6.813-.913-11.775-1.646c-9.932-1.44-23.632-3.522-38.756-5.883s-28.8-4.567-38.714-6.212l-11.725-1.975-3.176-.584a6.426,6.426,0,0,1-1.1-.255,5.027,5.027,0,0,1,1.127.091l3.209.42,11.75,1.72,38.755,5.957,38.714,6.138Z",
    transform: "translate(-34.158 -36.466)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M410.693,201.72c-.041.23-3.843-.214-8.5-.987s-8.434-1.58-8.344-1.753c0-.3,3.834.14,8.483.913S410.734,201.49,410.693,201.72Z",
    transform: "translate(-69.777 -35.236)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M390.373,213.038c-.041.23-3.843-.214-8.5-.987s-8.434-1.58-8.344-1.761,3.843.148,8.483.913S390.373,212.8,390.373,213.038Z",
    transform: "translate(-66.177 -37.248)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M363,232.09c-.041.23-3.851-.214-8.5-.987s-8.434-1.58-8.344-1.753c0-.3,3.834.14,8.483.913S363.044,231.86,363,232.09Z",
    transform: "translate(-61.328 -40.617)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M286.745,258.537c0,.23-28.725-3.991-64.074-9.43s-63.992-10.039-63.951-10.269,28.717,3.991,64.082,9.43S286.778,258.306,286.745,258.537Z",
    transform: "translate(-28.12 -42.312)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M284.414,299.056c-.041.239-9.446-1.094-21.007-2.962s-20.908-3.571-20.867-3.81,9.438,1.094,21.007,2.97S284.447,298.826,284.414,299.056Z",
    transform: "translate(-42.97 -51.778)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M413.913,189.62c-4.756.1-7.628,5.529-7.875,10.277s1.045,9.611-.115,14.219c-1.481,5.859-6.673,10.261-8.023,16.144-1.6,6.945,2.468,13.873,3.036,20.974.255,3.456-.337,6.994.469,10.359a12.754,12.754,0,0,0,25-.971c.823-5.381-1.777-10.927-.625-16.251.823-3.941,3.711-7.406,3.76-11.413.058-4.8-3.843-8.747-4.764-13.453s1.251-9.446,1.374-14.235c.222-8.6-3.653-15.157-12.236-15.634",
    transform: "translate(-70.429 -33.594)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M419.209,216.9a4.785,4.785,0,0,1,0,.757c0,.543-.082,1.267-.148,2.189-.14,1.934-.346,4.657-.592,8.014-.5,6.772-1.193,16.128-1.893,26.462s-1.275,19.7-1.687,26.479c-.206,3.357-.379,6.089-.494,8.023-.066.913-.115,1.646-.156,2.181a4.938,4.938,0,0,1-.082.757,4.852,4.852,0,0,1,0-.757c0-.543.041-1.267.066-2.189.091-1.942.206-4.674.354-8.031.329-6.788.823-16.152,1.555-26.5s1.44-19.69,2.032-26.454c.3-3.349.551-6.073.732-8.006.1-.913.173-1.646.23-2.18a4.743,4.743,0,0,1,.082-.749Z",
    transform: "translate(-73.372 -38.427)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M412.963,322.846h0a15.173,15.173,0,0,0,15.173-15.173V292.5H397.79v15.173a15.181,15.181,0,0,0,15.173,15.173Z",
    transform: "translate(-70.475 -51.821)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M397.79,301.51a2.115,2.115,0,0,1,.5.329l1.325,1.037,4.7,3.8h-.255l8.755-5.365h0l.14-.082.14.09,8.138,5.365H421l5.143-3.793,1.44-1.029a2.551,2.551,0,0,1,.543-.329,4.354,4.354,0,0,1-.461.436l-1.382,1.127-5.036,3.95-.115.091-.14-.082-8.179-5.3h.255l-8.788,5.291-.14.082-.115-.1-4.575-3.95-1.251-1.119a2.577,2.577,0,0,1-.411-.453Z",
    transform: "translate(-70.475 -53.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M397.79,297.822a2.032,2.032,0,0,1,.5.337l1.325,1.029,4.7,3.8h-.255l8.755-5.357h0l.14-.082.14.09,8.138,5.365H421l5.143-3.793,1.456-1.037a2.553,2.553,0,0,1,.543-.329,4.361,4.361,0,0,1-.461.436l-1.382,1.136-5.036,3.941-.115.1-.14-.091-8.179-5.3h.28l-8.788,5.283-.14.082-.115-.1-4.575-3.941-1.251-1.127a2.246,2.246,0,0,1-.452-.444Z",
    transform: "translate(-70.475 -52.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M397.79,305.263a2.114,2.114,0,0,1,.5.329l1.317,1.053,4.7,3.8h-.255l8.755-5.365h0l.14-.082.14.09,8.138,5.365H421l5.143-3.793,1.456-1.037a2.553,2.553,0,0,1,.543-.329,4.358,4.358,0,0,1-.461.436L426.3,306.86l-5.036,3.95-.115.091-.148-.14-8.179-5.3h.255l-8.788,5.3-.14.082-.115-.1-4.575-3.95-1.251-1.119a2.573,2.573,0,0,1-.42-.411Z",
    transform: "translate(-70.475 -54.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M439.814,422.51l9.693,27.779H444.66L427.71,422.51Z",
    transform: "translate(-75.776 -74.855)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M372.8,422.51l-9.685,27.779h4.838l16.959-27.779Z",
    transform: "translate(-64.333 -74.855)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1376",
    "data-name": "Rectangle 1376",
    width: 77.396,
    height: 77.396,
    transform: "translate(362.828 348.355) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1377",
    "data-name": "Rectangle 1377",
    width: 77.396,
    height: 77.396,
    transform: "translate(387.077 348.355) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M449.746,403.1H382.57V335.93h67.176Zm-66.172-1h65.177V336.926H383.582Z",
    transform: "translate(-67.779 -59.516)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M448.909,361.18c-21.846-.634-43.931-.469-65.786,0a.263.263,0,0,0,0,.527c21.854.444,43.939.609,65.786,0a.239.239,0,0,0,0-.469Z",
    transform: "translate(-67.83 -63.915)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M421.1,349.314a1.884,1.884,0,1,0,1.884-1.884,1.884,1.884,0,0,0-1.884,1.884Z",
    transform: "translate(-74.605 -61.553)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M454.08,386.054a1.884,1.884,0,1,0,1.884-1.884,1.884,1.884,0,0,0-1.884,1.884Z",
    transform: "translate(-80.448 -68.062)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M218.636,437.61,73.274,271.982a12.342,12.342,0,0,1,1.136-17.469L175.619,165.7a12.343,12.343,0,0,1,17.469,1.136l145.354,165.6A12.342,12.342,0,0,1,337.3,349.9L236.089,438.712a12.342,12.342,0,0,1-17.452-1.1Z",
    transform: "translate(-12.434 -28.81)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M337.253,370.7a16.917,16.917,0,1,1,1.555-23.862A16.917,16.917,0,0,1,337.253,370.7Z",
    transform: "translate(-54.775 -60.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M345.438,393.939a18.276,18.276,0,0,1-4.3.239,17.65,17.65,0,1,1,4.3-.239Zm-6.015-33.308a16.1,16.1,0,1,0,13.494,27.976h0a16.1,16.1,0,0,0-9.57-28.166A16.712,16.712,0,0,0,339.423,360.631Z",
    transform: "translate(-57.52 -63.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M131.6,257.4l-10.228,8.977-.922-1.053,9.29-8.146-2.115-2.419.93-.823Z",
    transform: "translate(-21.34 -44.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M132.353,277.75l-.938.823-6.295-7.167.749-.658,7.891.6c2.148.148,3.028-.23,3.736-.823,1.177-1.037,1.177-2.469-.2-4.073a4.6,4.6,0,0,0-3.588-1.794V263.35a6.114,6.114,0,0,1,4.641,2.345c1.818,2.074,1.917,4.312.214,5.809-.979.823-2.123,1.325-4.674,1.127l-6.467-.477Z",
    transform: "translate(-22.167 -46.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M145.853,289.9l-1.794-2.049-2.691,2.362-.88-1.053,2.691-2.353-5.069-5.76.757-.667,11.52-.527,1.029,1.168-11.191.568,3.892,4.435,2.37-2.074.9,1.02-2.37,2.074,1.8,2.049Z",
    transform: "translate(-24.468 -49.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M162.564,308.945l-1.8-2.049-2.682,2.362-.922-1.053,2.682-2.362-5.06-5.76.757-.667,11.52-.527,1.07,1.16-11.191.568,3.892,4.435,2.37-2.074.9,1.02-2.37,2.074,1.794,2.049Z",
    transform: "translate(-27.422 -52.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M172.383,318.946c-1.736,1.522-4.114,1.506-6.352-1a7,7,0,0,1-1.9-4.814l1.284-.222a5.883,5.883,0,0,0,1.572,4.18c1.522,1.736,3.176,1.917,4.419.823s1.415-2.691-.864-5.291l-1.909-2.172,5.587-3.974,4.937,5.6-.938.823-4.114-4.674-3.563,2.51,1.16,1.317C174.383,315.136,174.193,317.358,172.383,318.946Z",
    transform: "translate(-29.078 -54.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M183.35,331.375c-1.917,1.646-4.468,1.251-6.2-.741-2.386-2.715-1.8-5.842,1.432-8.681,3.472-3.045,6.953-2.74,9.389.041a6.229,6.229,0,0,1,1.572,2.9l-1.218.329a4.773,4.773,0,0,0-1.259-2.411c-1.942-2.205-4.6-2.378-7.406.058-.23.206-.518.469-.823.773a4.336,4.336,0,0,1,4.5,1.588C185.168,327.261,185.218,329.729,183.35,331.375Zm-.946-1.012c1.349-1.177,1.341-2.929-.049-4.509s-3.291-1.786-4.542-.666c-1.119.987-1.366,2.855.181,4.624,1.3,1.473,3.053,1.744,4.41.551Z",
    transform: "translate(-31.126 -56.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M198.015,348.123c-1.712,1.5-4.114,1.407-6.278-1.061a7.1,7.1,0,0,1-1.917-4.83l1.284-.222a5.941,5.941,0,0,0,1.6,4.213c1.489,1.7,3.094,1.934,4.369.823s1.275-2.641-.395-4.534l-.642-.732.773-.683,6.04-.28-4.591-5.233.938-.823,5.76,6.583L204.2,342l-6.171.3C199.842,344.576,199.653,346.683,198.015,348.123Z",
    transform: "translate(-33.63 -59.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M209.211,360.837c-1.909,1.646-4.46,1.259-6.2-.732-2.386-2.715-1.794-5.842,1.432-8.681,3.481-3.044,6.953-2.74,9.389.041a6.253,6.253,0,0,1,1.58,2.9l-1.226.329a4.706,4.706,0,0,0-1.259-2.411c-1.934-2.213-4.591-2.378-7.406.049-.23.214-.51.477-.823.782a4.336,4.336,0,0,1,4.493,1.58C211.037,356.731,211.078,359.2,209.211,360.837Zm-.938-1.012c1.341-1.177,1.333-2.921-.049-4.5s-3.291-1.786-4.542-.666c-1.127.987-1.374,2.855.181,4.624,1.292,1.473,3.053,1.736,4.41.543Z",
    transform: "translate(-35.708 -61.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M226.384,365.5l-.749.65-13.231,4.04-1-1.135,12.984-3.95-4.616-5.258-1.909,1.646-.913-1.029L219.793,358Z",
    transform: "translate(-37.453 -63.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M241.976,383.269l-.741.65L228,387.959l-1-1.136,12.984-3.95-4.616-5.274-1.917,1.646-.905-1.037,2.847-2.469Z",
    transform: "translate(-40.217 -66.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M245.238,402.3c-1.818,1.588-4.287,1.045-6.426-1.4s-2.337-4.937-.527-6.517a3.4,3.4,0,0,1,4.246-.239,3.061,3.061,0,0,1,.823-3.579c1.646-1.456,3.941-.954,5.842,1.21s2.131,4.517.461,5.974a3.069,3.069,0,0,1-3.678.346A3.439,3.439,0,0,1,245.238,402.3ZM244.3,401.2c1.259-1.1,1.094-2.88-.494-4.69s-3.291-2.18-4.567-1.078-1.127,2.872.461,4.682,3.316,2.18,4.583,1.078Zm.337-5.422c1.4,1.6,2.946,1.917,4.057.938s.971-2.633-.37-4.164-2.921-1.917-4.065-.913-1.029,2.543.362,4.131Z",
    transform: "translate(-41.998 -69.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M258.07,412.31c-3.481,3.053-6.953,2.74-9.389,0a6.147,6.147,0,0,1-1.572-2.913l1.218-.321a4.739,4.739,0,0,0,1.259,2.411c1.934,2.205,4.591,2.378,7.406-.058.23-.206.51-.477.823-.773a4.345,4.345,0,0,1-4.493-1.588c-1.786-2.032-1.827-4.5,0-6.138s4.46-1.251,6.2.732C261.888,406.344,261.3,409.479,258.07,412.31Zm.757-3.226c1.127-.987,1.374-2.863-.181-4.633-1.292-1.473-3.053-1.736-4.41-.543s-1.333,2.929.049,4.509,3.275,1.794,4.542.667Z",
    transform: "translate(-43.78 -71.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M275.2,421.052l-10.228,8.969-.922-1.053,9.29-8.154-2.115-2.411.93-.823Z",
    transform: "translate(-46.781 -73.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M275.973,441.391l-.938.823-6.295-7.167.749-.658,7.891.6c2.148.148,3.028-.23,3.727-.823,1.185-1.037,1.185-2.51-.189-4.073a4.6,4.6,0,0,0-3.588-1.794V427a6.114,6.114,0,0,1,4.641,2.345c1.818,2.073,1.917,4.312.214,5.809-.979.823-2.123,1.325-4.674,1.127l-6.467-.477Z",
    transform: "translate(-47.612 -75.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M287.975,450.621c-1.711,1.5-4.114,1.407-6.278-1.061a7.1,7.1,0,0,1-1.917-4.83l1.284-.222a5.941,5.941,0,0,0,1.6,4.213c1.489,1.7,3.094,1.934,4.369.823s1.275-2.641-.395-4.542l-.642-.732.773-.675,6.04-.28-4.616-5.241.938-.823,5.76,6.583-.749.658-6.171.3C289.835,447.075,289.613,449.181,287.975,450.621Z",
    transform: "translate(-49.568 -77.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1378",
    "data-name": "Rectangle 1378",
    width: 5.908,
    height: 108.993,
    transform: "matrix(0.751, -0.66, 0.66, 0.751, 154.447, 307.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1379",
    "data-name": "Rectangle 1379",
    width: 5.908,
    height: 55.903,
    transform: "translate(180.587 355.352) rotate(-41.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1380",
    "data-name": "Rectangle 1380",
    width: 45.733,
    height: 34.164,
    rx: 4.96,
    transform: "translate(139.161 175.809) rotate(48.73)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M146.56,231.439l1.646-1.44,15.527,17.7a4.937,4.937,0,1,0,7.406-6.509l-15.519-17.7,1.646-1.44,15.535,17.7a7.117,7.117,0,1,1-10.7,9.389Z",
    transform: "translate(-25.965 -39.34)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1381",
    "data-name": "Rectangle 1381",
    width: 2.189,
    height: 16.16,
    transform: "translate(144.637 210.35) rotate(-41.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1382",
    "data-name": "Rectangle 1382",
    width: 117.616,
    height: 10.096,
    transform: "translate(163.859 161.327) rotate(48.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M280.42,382H245.005v31.514L234.72,431.823H290.7L280.42,413.515Z",
    transform: "translate(-41.584 -67.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1383",
    "data-name": "Rectangle 1383",
    width: 285.885,
    height: 185.936,
    rx: 14.77,
    transform: "translate(78.186 129.588)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1384",
    "data-name": "Rectangle 1384",
    width: 85.69,
    height: 9.002,
    transform: "translate(178.283 364.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M176.154,170.32V335.134H118.465A13.165,13.165,0,0,1,105.3,322.018V183.436a13.165,13.165,0,0,1,13.165-13.116Z",
    transform: "translate(-18.656 -30.175)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M389.473,183.436V322.018a13.108,13.108,0,0,1-13.116,13.116H191.4V170.32H376.357A13.116,13.116,0,0,1,389.473,183.436Z",
    transform: "translate(-33.91 -30.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1385",
    "data-name": "Rectangle 1385",
    width: 268.886,
    height: 164.814,
    rx: 15.94,
    transform: "translate(86.686 140.145)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1386",
    "data-name": "Rectangle 1386",
    width: 192.806,
    height: 127.111,
    transform: "translate(124.725 158.231)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1387",
    "data-name": "Rectangle 1387",
    width: 189.449,
    height: 114.843,
    transform: "translate(126.379 167.751)",
    fill: "#352628"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1388",
    "data-name": "Rectangle 1388",
    width: 187.252,
    height: 113.041,
    transform: "translate(127.482 168.648)",
    fill: "#443637"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1389",
    "data-name": "Rectangle 1389",
    width: 7.455,
    height: 4.443,
    transform: "translate(141.396 177.271)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1390",
    "data-name": "Rectangle 1390",
    width: 42.162,
    height: 4.443,
    transform: "translate(151.903 177.271)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1391",
    "data-name": "Rectangle 1391",
    width: 27.557,
    height: 4.443,
    transform: "translate(201.224 177.271)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1392",
    "data-name": "Rectangle 1392",
    width: 28.314,
    height: 4.443,
    transform: "translate(148.398 185.17)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1393",
    "data-name": "Rectangle 1393",
    width: 25.755,
    height: 4.443,
    transform: "translate(179.213 194.057)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1394",
    "data-name": "Rectangle 1394",
    width: 25.755,
    height: 4.443,
    transform: "translate(210.111 194.057)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1395",
    "data-name": "Rectangle 1395",
    width: 4.657,
    height: 4.443,
    transform: "translate(240.251 194.057)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1396",
    "data-name": "Rectangle 1396",
    width: 7.471,
    height: 4.443,
    transform: "translate(248.537 194.057)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1397",
    "data-name": "Rectangle 1397",
    width: 38.969,
    height: 4.443,
    transform: "translate(221.161 185.17)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1398",
    "data-name": "Rectangle 1398",
    width: 32.576,
    height: 4.443,
    transform: "translate(181.887 185.17)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1399",
    "data-name": "Rectangle 1399",
    width: 38.969,
    height: 4.452,
    transform: "translate(157.227 201.8)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1400",
    "data-name": "Rectangle 1400",
    width: 11.265,
    height: 4.443,
    transform: "translate(157.227 209.921)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1401",
    "data-name": "Rectangle 1401",
    width: 19.789,
    height: 4.443,
    transform: "translate(173.363 209.921)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1402",
    "data-name": "Rectangle 1402",
    width: 14.918,
    height: 4.443,
    transform: "translate(201.372 209.921)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1403",
    "data-name": "Rectangle 1403",
    width: 14.918,
    height: 4.443,
    transform: "translate(219.943 209.921)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1404",
    "data-name": "Rectangle 1404",
    width: 19.485,
    height: 4.443,
    transform: "translate(170.318 218.331)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1405",
    "data-name": "Rectangle 1405",
    width: 62.716,
    height: 4.443,
    transform: "translate(192.239 218.331)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1406",
    "data-name": "Rectangle 1406",
    width: 19.485,
    height: 4.443,
    transform: "translate(157.227 226.748)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1407",
    "data-name": "Rectangle 1407",
    width: 9.742,
    height: 4.443,
    transform: "translate(180.365 226.748)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1408",
    "data-name": "Rectangle 1408",
    width: 34.707,
    height: 4.443,
    transform: "translate(195.283 226.748)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1409",
    "data-name": "Rectangle 1409",
    width: 10.656,
    height: 4.443,
    transform: "translate(172.754 235.166)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1410",
    "data-name": "Rectangle 1410",
    width: 4.567,
    height: 4.443,
    transform: "translate(187.063 235.166)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1411",
    "data-name": "Rectangle 1411",
    width: 11.865,
    height: 4.443,
    transform: "translate(197.414 235.166)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1412",
    "data-name": "Rectangle 1412",
    width: 28.314,
    height: 4.443,
    transform: "translate(212.637 235.166)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1413",
    "data-name": "Rectangle 1413",
    width: 14.309,
    height: 4.443,
    transform: "translate(244.916 235.166)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1414",
    "data-name": "Rectangle 1414",
    width: 43.841,
    height: 4.443,
    transform: "translate(262.871 235.166)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1415",
    "data-name": "Rectangle 1415",
    width: 19.485,
    height: 4.443,
    transform: "translate(172.754 243.583)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1416",
    "data-name": "Rectangle 1416",
    width: 13.091,
    height: 4.443,
    transform: "translate(198.328 243.583)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1417",
    "data-name": "Rectangle 1417",
    width: 13.091,
    height: 4.443,
    transform: "translate(216.595 243.583)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    width: 49.008,
    height: 4.443,
    transform: "translate(172.754 252.001)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1419",
    "data-name": "Rectangle 1419",
    width: 25.878,
    height: 4.443,
    transform: "translate(226.032 252.001)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 19.485,
    height: 4.443,
    transform: "translate(157.227 260.41)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 14.005,
    height: 4.443,
    transform: "translate(181.887 260.41)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 33.637,
    height: 4.443,
    transform: "translate(200.154 260.41)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 16.745,
    height: 4.443,
    transform: "translate(236.236 260.41)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1424",
    "data-name": "Rectangle 1424",
    width: 42.318,
    height: 4.443,
    transform: "translate(255.868 260.41)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    width: 19.485,
    height: 4.443,
    transform: "translate(172.754 268.828)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    width: 15.831,
    height: 4.443,
    transform: "translate(198.788 268.828)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1427",
    "data-name": "Rectangle 1427",
    width: 10.203,
    height: 4.443,
    transform: "translate(220.396 268.828)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1428",
    "data-name": "Rectangle 1428",
    width: 35.769,
    height: 4.443,
    transform: "translate(236.384 268.828)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    "data-name": "Rectangle 1429",
    width: 10.195,
    height: 4.443,
    transform: "translate(276.11 268.828)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 10.96,
    height: 4.452,
    transform: "translate(203.503 201.8)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M358.38,197.709a2.008,2.008,0,1,0,2.008-2,2.008,2.008,0,0,0-2.008,2Z",
    transform: "translate(-63.493 -34.673)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M367.88,197.709a2.008,2.008,0,1,0,2.008-2,2.008,2.008,0,0,0-2.008,2Z",
    transform: "translate(-65.176 -34.673)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M377.38,197.709a2.008,2.008,0,1,0,2-2,2.008,2.008,0,0,0-2,2Z",
    transform: "translate(-66.859 -34.673)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M241.334,118.88A127.28,127.28,0,1,0,368.61,246.164C368.61,175.976,311.489,118.88,241.334,118.88Zm87.508,188.281a106.664,106.664,0,1,1,19.2-61,106.968,106.968,0,0,1-19.2,61Z",
    transform: "translate(-20.206 -21.062)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M349.731,328.6a127.362,127.362,0,0,1-13.313,15.634L320.7,330.851l-161.7-137.668L143.29,179.8a128.077,128.077,0,0,1,13.338-15.634l15.724,13.379,161.67,137.635Z",
    transform: "translate(-25.386 -29.085)",
    fill: "red"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCoding);
export default __webpack_public_path__ + "static/media/no-coding.32df8b92f201a7bd910ead122ae66bfa.svg";
export { ForwardRef as ReactComponent };